import React, { useState,useEffect,useMemo,useCallback} from "react";
import axios from "axios";
import "./ListLivrables.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from 'primereact/card';
import { FaRegFileAlt,  FaDownload } from "react-icons/fa";
import JSZip from 'jszip';
import {
  BsFileEarmarkCodeFill,
  BsFillFileEarmarkZipFill,
  BsFileEarmarkImage,
  BsFillFileEarmarkMusicFill,
  BsFileEarmark,
  BsFileEarmarkExcel,
  BsFillFileEarmarkPptFill,
  BsFillFilePlayFill,
  BsFileEarmarkPdf,
  BsFillFileEarmarkWordFill,
} from "react-icons/bs";
import { Dialog } from "primereact/dialog";
import ShareFile from "./ShareFile";
import moment from "moment";

import { partial } from "filesize";
import NousContacterDevis from "../../DemandeDevisService/demandeDevisService";
import { baseURL } from "../../../api";
// import ObjectUtils from 'primereact/components/utils/ObjectUtils';
import { useLivrable } from "../../../Context/LivrableContext";
import { useService } from "../../../Context/ServiceContext";
import { Button } from "primereact/button";

// put near other imports/utilities
const sizeFn = partial({ base: 2, standard: "jedec" });

const formatBytes = (input) => {
  // accept numbers or numeric strings; ignore everything else
  const n = typeof input === "number" ? input : Number(String(input ?? "").replaceAll(",", "").trim());
  if (!Number.isFinite(n) || n < 0) return "—";
  return sizeFn(n);
};

export const ListLivrables = (
  { idActif, 
 }
) => {
  const{ livrable}=useLivrable()
  const {service , setSelectedService}=useService()
  
  const [dialogShare, setDialogShare] = useState(false);
  const [expandedLivrable, setExpandedLivrable] = useState(null);
  const [openDialogContact, setDialog] = useState(false);
  const [livrableNom, setLivrableNom] = useState();
  const [livrableId, setLivrableId] = useState();
  const [expandedRows, setExpandedRows] = useState([]);
   // Par défaut, tri ascendant
   const [fileSort, setFileSort] = useState({ by: "date", asc: true }); 

  const [allFilesExpanded, setAllFilesExpanded] = useState(false);
  const [tabFichierVisibility, setTabFichierVisibility] = useState({});



  const handleSortFiles = useCallback((fichiers = []) => {
  const arr = [...fichiers]; // IMPORTANT: ne pas muter l'array d'origine
  const { by, asc } = fileSort;

  return arr.sort((a, b) => {
    if (by === "name") {
      const A = (a?.nom ?? "").toString();
      const B = (b?.nom ?? "").toString();
      const cmp = A.localeCompare(B, "fr", { sensitivity: "base" });
      return asc ? cmp : -cmp;
    } else {
      const A = new Date(a?.date_mise_a_disposition ?? 0).getTime();
      const B = new Date(b?.date_mise_a_disposition ?? 0).getTime();
      return asc ? A - B : B - A;
    }
  });
}, [fileSort]);
 
 const toggleFiles = (rowData) => {
  const isCurrentlyExpanded = expandedRows[rowData.name];
  if (isCurrentlyExpanded) {
    // Collapse all files for this service
    setExpandedRows((prev) => {
      const updated = { ...prev };
      delete updated[rowData.name];
      return updated;
    });
  } else {
    // Expand all files for this service
    setExpandedRows((prev) => ({
      ...prev,
      [rowData.name]: true,
    }));
  }
  setAllFilesExpanded(!allFilesExpanded);
};
const toggleTabFichier = (serviceName) => {
  setTabFichierVisibility((prev) => ({
    ...prev,
    [serviceName]: !prev[serviceName], 
  }));
};

const TailleTotaleTemplate = (rowData) => {
  // Récupérer tous les fichiers du service
  const allFiles = rowData.value.flatMap(livrable => livrable.fichiers || []);

  // Somme des tailles
  //const totalSize = allFiles.reduce((acc, fichier) => acc + (fichier.taille || 0), 0);
  const totalSize = allFiles.reduce((acc, f) => {
    const n = typeof f?.taille === "number" ? f.taille : Number(String(f?.taille ?? "").replaceAll(",", "").trim());
    return Number.isFinite(n) ? acc + n : acc;
  }, 0);
  // Formater en taille lisible
  //const sizeFormatter = partial({ base: 2, standard: "jedec" });
  return <span className="totalsize-col" style={{ 
      
        whiteSpace: "nowrap"  
      }}>
      {/*{sizeFormatter(totalSize)}*/}
      {formatBytes(totalSize)}
    </span>
};



  
  let services= Object.values(service)
  let livrables= Object.values(livrable)
  

  let livrableService = {};
  services?.forEach((service) => (livrableService[service.libelle] = []));
  services?.map((service) => {
    return livrables?.forEach((livrable) => {
      if (livrable.id_type_service_gexpertise === service.id_type_service_gexpertise) {
       livrableService[service.libelle].push(livrable);
      }
    });
  });
  {/*const livrableParService = Object.entries(livrableService).map((item) => {
    const [key, value] = item;
    return {
      name: key,
      value: value,
    };
  });*/}
  // Memoize livrableParService to avoid re-creation on every render
  const livrableParService = useMemo(() => {
    const livrableService = {};
    Object.values(service).forEach(
      (service) => (livrableService[service.libelle] = [])
    );
    Object.values(service).forEach((service) => {
      Object.values(livrable).forEach((livrable) => {
        if (
          livrable.id_type_service_gexpertise === service.id_type_service_gexpertise
        ) {
          livrableService[service.libelle].push(livrable);
        }
      });
    });
    return Object.entries(livrableService).map(([key, value]) => ({
      name: key,
      value: value,
    }));
  }, [service, livrable]);
   
   // Automatically expand rows with data on initial load
  useEffect(() => {
    const initialExpandedRows = {};
    livrableParService.forEach((service) => {
      if (service.value.length > 0) {
        initialExpandedRows[service.name] = true;
      }
    });
    setExpandedRows(initialExpandedRows);
  }, [livrableParService]);

  const handleRowToggle = (event) => {
    setExpandedRows(event.data); // Update expanded rows based on user interaction
  };


  const NbreFichierTemplate = (data) => {
    var tab = 0;
    if (data.value.length)
      for (var i = 0; i < data.value.length; i++) {
        if (data.value[i].fichiers.length > 0) {
          tab++;
        }
      }
   
    return (
      <>
        <FaRegFileAlt />
        {tab}
      </>
    );
  };
  
  




  const  livrableVide =(value)=> {   

        // if(value.fichiers?.map((f)=>f.nom).length===0)
        
        if(value.fichiers?.map((f)=>f.nom).length===0)
     return {
       "emptymessageLivrable": true,
       };

  };
  // Automatically expand non-empty rows
  {/*useEffect(() => {
    const initialExpandedRows = {};
    livrableParService.forEach((service) => {
      if (service.value.length > 0) {
        initialExpandedRows[service.name] = true;
      }
    });
    setExpandedRows((prev) => ({ ...prev, ...initialExpandedRows }));
  }, [livrableParService]);*/}
  
  

 
  
  


  
  const rowExpansionTemplate = (data) => {
    const allFiles = data.value.flatMap((livrable) => livrable.fichiers || []);
    

    return (
      <div style={{ width: "100%" }}>

      <div className="TabLivrable" style={{ width: "100%" }}>
        <DataTable
          value={data.value}
          responsiveLayout="scroll"
          rowClassName={livrableVide}
          emptyMessage={
            <>
              {`Désolé vous n'avez pas de livrable issu du service «${data.name} ».`}
              <Button
                className="serviceVide"
                onClick={() => {
                
                  
                  setSelectedService(data.name)
                    setDialog(true);
                }}
              >
                {" "}
                souhaitez-vous un devis ?
              </Button>
            </>
          }
          onRowToggle={(e) => setExpandedLivrable(e.data)}
          // rowClassName={rowClassName}
          expandedRows={expandedLivrable}
          rowExpansionTemplate={rowExpansionLivrable}
          className="tablivrablexpand"
        >
          <Column
            expander
            style={{ width: "1em" }}
            hidden={data.value.every((v)=>v.fichiers?.length===0) ? true : false}
                 />
            <Column
            field="nom"
            hidden={data.value.every((v)=>v.fichiers?.length===0) ? true : false}
            style={{ width: "20rem" }}
            
          ></Column>
          
          <Column
            body={
            
              <>
              {`Désolé vous n'avez pas de livrable issu du service «${data.name} ».`}
              <Button
                className="serviceVide"
                onClick={() => {
                
                
                  setSelectedService(data.name)
                    setDialog(true);
                }}
              >
                {" "}
                souhaitez-vous un devis ?
              </Button>
            </>
            }
        hidden={data.value.every((v)=>v.fichiers?.length===0) ? false : true}
      
          ></Column>
          <Column style={{ minWidth: "3rem" }} />
          <Column style={{ minWidth: "4rem" }} />
          <Column body={partageLivrable} 
hidden={data.value.every((v)=>v.fichiers?.length===0) ? true : false}
/>
          
          
          <Column
            body={btnDownloadLivrable}
        
          />
          
        </DataTable>
      </div>
      {/* TabFichier section - conditionally rendered */}
      {tabFichierVisibility[data.name] && (
        
        <div className="TabFichier" style={{ width: "103%" ,marginLeft:"-17px"}}>
          
          <DataTable style={{width:"100%"}} value={allFiles} responsiveLayout="scroll">
          <Column 
   body={ActionFichier} 
   style={{ width: "4%", textAlign: "center" }} 
   className="action-column"
/>

             <Column body={extensionFile} style={{ width: "56%" }} />
             <Column
                body={dateMiseADisposition}
                style={{ width: "18%" }}
                className="fileDescription"
             />
             <Column
                body={tailleFichier}
                style={{ width: "18%" }}
                className="fileDescription"
             />
          </DataTable>
        </div>
      )}
    </div>
  );
};
  
  const dateMiseADisposition = (fichiers) => {
    return <>{moment(fichiers.date_mise_a_disposition).format("DD/MM/YYYY")}</>;
  };

  {/*const tailleFichier = (fichiers) => {
    const size = partial({ base: 2, standard: "jedec" });
    size(fichiers.taille);
   
    return size(fichiers.taille);
  };*/}
  const tailleFichier = (fichiers) => {
  return <>{formatBytes(fichiers?.taille)}</>;
};

  
  const extensionFile = (fichiers) => {
    let returnIconClass = "";
    switch (fichiers?.extension?.toLowerCase()) {
      case "apng":
      case "gif":
      case "ico":
      case "jpeg":
      case "jpg":
      case "png":
      case "svg":
      case "tif":
      case "tiff":
      case "webp":
        returnIconClass = <BsFileEarmarkImage style={{ color: "#4040b5ba" }} />;
        break;

      case "aac":
      case "mid":
      case "midi":
      case "oga":
      case "wav":
      case "mp3":
      case "weba":
        returnIconClass = (
          <BsFillFileEarmarkMusicFill style={{ color: "#4040b5ba" }} />
        );
        break;
      case "avi":
      case "mpeg":
      case "mkv":
      case "ogv":
      case "webm":
      case "3gp":
      case "3g2":
        returnIconClass = <BsFillFilePlayFill style={{ color: "#4040b5ba" }} />;
        break;
      case "pdf":
        returnIconClass = <BsFileEarmarkPdf style={{ color: "#f80539a1" }} />;
        break;
      case "doc":
      case "docx":
      case "odt":
        returnIconClass = (
          <BsFillFileEarmarkWordFill style={{ color: "#4040b5ba" }} />
        );

        break;
      case "odp":
      case "ppt":
      case "pptx":
        returnIconClass = (
          <BsFillFileEarmarkPptFill style={{ color: "#4040b5ba" }} />
        );

        break;
      case "csv":
      case "ods":
      case "xls":
      case "xlsx":
        returnIconClass = <BsFileEarmarkExcel style={{ color: "#4040b5ba" }} />;

        break;
      case "txt":
      case "rtf":
        returnIconClass = <BsFileEarmark style={{ color: "#4040b5ba" }} />;

        break;
      case "htm":
      case "html":
      case "css":
      case "scss":
      case "js":
      case "ts":
      case "json":
      case "sh":
      case "swf":
      case "xhtml":
      case "xml":
        returnIconClass = (
          <BsFileEarmarkCodeFill style={{ color: "#4040b5ba" }} />
        );

        break;
      case "7z":
      case "rar":
      case "zip":
      case "bz":
      case "bz2":
      case "tar":
        returnIconClass = (
          <BsFillFileEarmarkZipFill style={{ color: "#4040b5ba" }} />
        );

        break;
      default:
        returnIconClass = <BsFileEarmark style={{ color: "#4040b5ba" }} />;
    }
    return (
      <>
        {returnIconClass} {fichiers.nom}
      </>
    );
  };

  const rowExpansionLivrable = (value) => {
    return (
      <div className="TabFichier">
      {/* En-tête avec style aligné */}
      <div className="header-sort-container">
         <div className="header-row">
            <div className="header-column" style={{ width: "60%", textAlign: "left" }}>
               <span className="header-text1">Nom</span>
              <Button
  icon={
    fileSort.by === "name"
      ? (fileSort.asc ? "pi pi-sort-alpha-down" : "pi pi-sort-alpha-up-alt")
      : "pi pi-sort-alt"
  }
  className="sort-button2"
  onClick={() =>
    setFileSort(s => ({
      by: "name",
      asc: s.by === "name" ? !s.asc : true, // si on re-clique sur "Nom", on inverse le sens
    }))
  }
/>
               
            </div>
            <div className="header-column">
               <span className="header-text">Date de mise en ligne</span>
              <Button
  icon={
    fileSort.by === "date"
      ? (fileSort.asc ? "pi pi-sort-amount-up" : "pi pi-sort-amount-down")
      : "pi pi-sort-alt"
  }
  className="sort-button"
  onClick={() =>
    setFileSort(s => ({
      by: "date",
      asc: s.by === "date" ? !s.asc : true, // si on re-clique sur "Date", on inverse le sens
    }))
  }
/>
            </div>
         </div>
      </div>

          {/* Tableau des fichiers avec tri dynamique */}
          <DataTable
             value={handleSortFiles(value.fichiers || [])}
             responsiveLayout="scroll"
             className="TabFichier"
          >
<Column 
   body={ActionFichier} 
   style={{ width: "4%", textAlign: "center" }} 
   className="action-column"
/>

             <Column body={extensionFile} style={{ width: "56%" }} />
             <Column
                body={dateMiseADisposition}
                style={{ width: "18%" }}
                className="fileDescription"
             />
             <Column
                body={tailleFichier}
                style={{ width: "25%"}}
                className="fileDescription"
             />
          </DataTable>
       </div>
    );
 };
 
  // const IncrementNumberDownload =(fichiers)=>{
  //                     console.log('nom fichiers:', rowData.id );
  //                     // setCount(count+1)
  //                     var number = ++(rowData.numberDowload)

  //             }}
  
  const ActionFichier = (rowData) => {
    const handleDownload = async () => {
      try {
        // Retrieve the token from localStorage or sessionStorage
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  
        // Check if token exists
        if (!token) {
          alert("You are not authenticated. Please log in.");
          return;
        }
  
       
  
        // Perform the file download request
        const response = await axios.get(
          `${baseURL}/api/fichiers/download/${rowData.id_fichier_gexpertise}/${rowData.nom}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the user's token dynamically
            },
            responseType: 'blob', // Ensure we get the file as a blob
          }
        );
  
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${rowData.nom}.${rowData.extension}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) { ;
        alert("Failed to download file");
      }
    };
  
    return (
      <div>
        <FaDownload
          style={{ color: "#970121", cursor: "pointer" }}
          onClick={handleDownload}
        />
      </div>
    );
  };
  
  
  const sortFilesByDate = (fichiers) => {
    if (!fichiers) return [];
    return fichiers.sort((a, b) => {
      const dateA = new Date(a.date_mise_a_disposition);
      const dateB = new Date(b.date_mise_a_disposition);
      return dateB - dateA; // Tri décroissant (du plus récent au plus ancien)
    });
  };
  
  // util sûr → timestamp
const toTs = (d) => {
  const t = new Date(d ?? 0).getTime();
  return Number.isFinite(t) ? t : null;
};

const sortedLivrableParService = useMemo(() => {
  // on repart de livrableParService (déjà calculé plus haut)
  const groups = livrableParService.map((grp) => {
    // garder ton tri interne des fichiers si tu veux
    const valueSorted = (grp.value || []).map((item) => ({
      ...item,
      fichiers: sortFilesByDate(item.fichiers || []),
    }));

    // aplatir tous les fichiers du service
    const allFiles = valueSorted.flatMap((l) => l.fichiers || []);
    const ts = allFiles
      .map((f) => toTs(f.date_mise_a_disposition))
      .filter((n) => n !== null);

    // *** dernière date (max) ***
    const last = ts.length ? new Date(Math.max(...ts)) : null;

    // IMPORTANT : on pose le champ que ta colonne utilise déjà
    return {
      ...grp,
      value: valueSorted,
      date_mise_a_disposition: last, // <- la colonne lira ici
    };
  });

  // tri initial (plus récent → plus ancien) si tu veux garder l’ordre par défaut
  groups.sort((a, b) => {
    const A = a.date_mise_a_disposition ? a.date_mise_a_disposition.getTime() : -Infinity;
    const B = b.date_mise_a_disposition ? b.date_mise_a_disposition.getTime() : -Infinity;
    return B - A;
  });

  return groups;
}, [livrableParService]);

  
  const btnDownloadActif = async () => {
  try {
    const zip = new JSZip();
    const filteredLivrables = livrables.filter(
      (livrable) => livrable.id_type_service_gexpertise
    );
    const fileLogs = []; // Collect file logs for backend tracking

    // Récupérer le token d'authentification
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (!token) {
      
      return;
    }

    // Parcourir tous les livrables pour ajouter leurs fichiers dans un seul ZIP global
    for (let livrable of filteredLivrables) {
      if (livrable?.fichiers?.length > 0) {
        const folderName = `${livrable.nom}_${livrable.id_livrable_gexpertise}`;
        const folder = zip.folder(folderName);

        for (let fichier of livrable.fichiers) {
          try {
            // CORRECTION: Utiliser axios avec authentification au lieu de fetch
            const response = await axios.get(
              `${baseURL}/api/fichiers/download/${fichier.id_fichier_gexpertise}/${fichier.nom}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                responseType: 'blob',
              }
            );

            folder.file(`${fichier.nom}.${fichier.extension}`, response.data);
            
            // Log the file download
            fileLogs.push({
              id_fichier_gexpertise: fichier.id_fichier_gexpertise,
              nom: fichier.nom,
            });
          } catch (error) {
            
          }
        }
      }
    }

    // Send file logs to the backend for tracking
    if (fileLogs.length > 0) {
      try {
        await axios.post(
          `${baseURL}/api/fichiers/log-downloads`,
          { files: fileLogs },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
      } catch (error) {
       
      }
    }

  
    const zipData = await zip.generateAsync({ type: "blob" });

    // Créer un lien de téléchargement pour le ZIP global
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(zipData);
    link.download = "Livrables_Complets.zip";
    link.click();
  } catch (error) {
    
    alert("Failed to download files");
  }
};

// Fonction corrigée pour télécharger tous les fichiers d'un livrable
const downloadLivrable = async (rowData) => {
  try {
    const zip = new JSZip();
    const fileLogs = [];

    // Récupérer le token d'authentification
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (!token) {
      return;
    }

    for (let i = 0; i < rowData?.fichiers?.length; i++) {
      try {
        const fichier = rowData.fichiers[i];
        
        // CORRECTION: Utiliser axios avec authentification au lieu de fetch
        const response = await axios.get(
          `${baseURL}/api/fichiers/download/${fichier.id_fichier_gexpertise}/${fichier.nom}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: 'blob',
          }
        );

        zip.file(`${fichier.nom}.${fichier.extension}`, response.data);
        
        fileLogs.push({
          id_fichier_gexpertise: fichier.id_fichier_gexpertise,
          nom: fichier.nom,
        });
      } catch (error) {
       
      }
    }

    // Send file logs to the backend for tracking
    if (fileLogs.length > 0) {
      try {
        await axios.post(
          `${baseURL}/api/fichiers/log-downloads`,
          { files: fileLogs },
          { headers: { Authorization: `Bearer ${token}` } }
        );
       
      } catch (error) {
        
      }
    }

    // Generate the zip file
    const zipData = await zip.generateAsync({
      type: "blob",
      streamFiles: true,
    });

    // Create a download link for the zip file
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(zipData);
    link.download = `${rowData.nom}.zip`;
    link.click();
  } catch (error) {
  
    alert("Failed to download files");
  }
};
  
 



  const partageLivrable = (rowData) => {
    //Partager le livrable y compris  tt les fichiers
       
    return (
      <>
     { rowData.fichiers?.length===0 ? "" : <Button
          className="btn-tab1"
          onClick={(e) => {
            shareFile(e, rowData.id_livrable_gexpertise, rowData.nom);
          }}
        >
          {/* <FaShareAlt style={{ color: "#970121" }} /> */} 
          Envoyer un lien de téléchargement du livrable complet
        </Button>}
      </>
    );
  };
 const btnDownloadLivrable=(rowData)=> {

    return (
      
        <Button className="btn-tab2" onClick={() => downloadLivrable(rowData)}>
        Télécharger tous les fichiers du livrable
      </Button>


      
   
  )
 }
 const dateMiseEnLigneServiceTemplate = (row) =>
  row?.date_mise_a_disposition ? moment(row.date_mise_a_disposition).format("DD/MM/YYYY") : "—";

  const shareFile = (e, livrableId, livrableNom) => {
    e.preventDefault();
      
    setLivrableId(livrableId);
    setLivrableNom(livrableNom);
    setDialogShare(true);
  };



  const rowClassNameService = (data) => {
    var tab = 0;
    if (data.value.length)
      for (var i = 0; i < data.value.length; i++) {
        if (data.value[i].fichiers.length > 0) {
          tab++;
        }
      }
      let hasFiles = tab > 0; // Determines if the service has files
      return {
        "p-datatable-service-empty": !hasFiles, // Class for services without files
        "p-datatable-service-non-empty": hasFiles, // Class for services with files
       
      };
    };
  
    
    function getMostRecentDate(livrable) {
      if (livrable.value && livrable.value.length > 0) {
        const fichiers = livrable.value.flatMap((item) => item.fichiers || []);
        if (fichiers.length > 0) {
          const sortedFiles = sortFilesByDate(fichiers);
          return new Date(sortedFiles[0].date_mise_a_disposition);
        }
      }
      return new Date(0); // Date par défaut pour les livrables sans fichiers
    }
    
  
    
    
  return (
    <div className="listeLivrable">
  <Card> 
  <div className="entet-livrable">
   <h5>Liste des livrables</h5>  
   <Button label="Télécharger tous les livrables de cet actif" className="btn-tab1" onClick={btnDownloadActif} />
  
   </div>
  
    <div className="datatable-rowexpansion-demo">
   
      {/* Liste des service  */}
      <div className="TabService">
        <DataTable
  value={sortedLivrableParService}
  rowExpansionTemplate={rowExpansionTemplate}
  onRowToggle={(e) => setExpandedRows(e.data)}
  responsiveLayout="scroll"
  rowClassName={rowClassNameService}
  className="tabGexLivrable"
  expandedRows={expandedRows}
  dataKey="name"
  sortField="date_mise_a_disposition"   // <-- CORRIGÉ
  sortOrder={-1}                        // plus récent → plus ancien
>
  <Column expander style={{ width: "1%" }} />

  <Column field="name" style={{ width: "50%" }} />

  <Column body={NbreFichierTemplate} style={{ width: "5%" }} />
  <Column body={TailleTotaleTemplate} className="totalsize-col" />

  <Column
    field="date_mise_a_disposition"
    header="Dernière mise en ligne"
    className="fileDescription"
    style={{ width: "18%" }}
    sortable
    dataType="date"                      // <-- important pour trier des Date
    body={dateMiseEnLigneServiceTemplate} // (garde ton body formatter)
  />

  <Column header="Taille du fichier" className="fileDescription" style={{ width: "18%" }} />
  <Column />
</DataTable>

      </div>
      <Dialog
        header={
          "Envoyez un lien de téléchargement des fichiers qui composent le livrable  " +
          livrableNom +
          " à une ou plusieurs personnes"
        }
        visible={dialogShare}
        style={{ width: "50vw" }}
        onHide={() => setDialogShare(false)}
      >
        <ShareFile
          setDialogShare={setDialogShare}

          livrableId={livrableId}
       
          livrableNom={livrableNom}
        />
      </Dialog>
       </div>
    </Card>
    <Dialog header="Demandez un devis" visible={openDialogContact} style={{ width: '50vw' }} onHide={() => setDialog(false)} >
                <NousContacterDevis setDialog={setDialog}  />
            </Dialog>
    </div>
    
  );
  
};
